import { BillingStrategy } from '@galaxy/billing';
import { OrderConfirmationItem } from '../interface';
import { AppNameAndEditionNamePair } from './order-summary.component';

export function getBilledOrderItemsForStrategy(
  items: OrderConfirmationItem[],
  isInstantBilledMap: Map<string, BillingStrategy>,
  billingStrategy: BillingStrategy,
): OrderConfirmationItem[] {
  const instantBilledItems = [];
  if (!items || items.length === 0) {
    return [];
  }

  items.forEach((item) => {
    // Using the addonId for checking if the item is instant billed (rather than the parent app),
    // Falling back to the appId if there is no addonId
    if (billingStrategy === isInstantBilledMap.get(item.addonId || item.appId)) {
      instantBilledItems.push(item);
    }
  });
  return instantBilledItems;
}

export function formatApprovalMessage(appAndEditionNames: AppNameAndEditionNamePair[]): string {
  if (!appAndEditionNames || appAndEditionNames.length === 0) {
    return '';
  }

  let s = '';
  appAndEditionNames.forEach((appAndEditionName) => {
    let names = `${appAndEditionName.appName}`;
    if (appAndEditionName.editionName) {
      names = `${names} ${appAndEditionName.editionName}`;
    }
    s = `${s} ${names}, `.trim();
  });
  s = s.substring(0, s.length - 1); // remove the last comma

  return s;
}
